import { Link } from "react-scroll";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation();
  const points = t("aboutPoints", { returnObjects: true });

  return (
    <section className="about" id="about-scroll">
      <div className="container about-inner">
        <div className="about-copy">
          <p className="about-eyebrow">{t("aboutEyebrow")}</p>
          <h2 className="main-title about-h2">{t("aboutTitle")}</h2>
          <p className="about-lead">{t("aboutLead")}</p>
          <p className="main-p">{t("about")}</p>

          {Array.isArray(points) && (
            <ul className="about-points">
              {points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          )}

          <Link
            to="contact"
            spy={true}
            smooth={true}
            duration={800}
            className="about-cta"
          >
            {t("aboutCta")}
          </Link>
        </div>

        <div className="about-visual" aria-hidden="true">
          <img
            alt=""
            src={process.env.PUBLIC_URL + "/img/landing/about-img.png"}
            className="img-fluid"
          />
        </div>
      </div>
    </section>
  );
}

export default About;
